import { useEffect } from "react";
import Lenis from "lenis";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import MarqueeRibbon from "@/components/landing/MarqueeRibbon";
import Programme from "@/components/landing/Programme";
import Registration from "@/components/landing/Registration";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    window.__lenis = lenis;
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-[#FDFBF7] text-[#1A1512] font-sans overflow-x-clip" data-testid="landing-page">
      <Header />
      <Hero />
      <MarqueeRibbon />
      <Programme />
      <Registration />
      <Footer />
    </div>
  );
}
